import { auth, db } from "../../firebase";
import {
  collection, query, where, orderBy, getDocs, addDoc, 
  doc, updateDoc, deleteDoc, getDoc, serverTimestamp
} from "firebase/firestore";

const tasksCol = collection(db, "space_tasks"); // 🌟 Isolated Collection

/**
 * Helper for date conversion to prevent .toDate() crashes
 */
const safeDate = (field) => {
  if (!field) return null;
  if (typeof field.toDate === 'function') return field.toDate();
  return new Date(field);
};

export async function getSpaceTasks(spaceId) {
  const user = auth.currentUser;
  if (!user) throw new Error("Not authenticated");

  // 🌟 Query filtered strictly by spaceId
  const q = query(
    tasksCol,
    where("spaceId", "==", spaceId),
    orderBy("createdAt", "desc")
  );
  const snap = await getDocs(q);

  return snap.docs.map(d => ({
    id: d.id,
    ...d.data(),
    createdAt: safeDate(d.data().createdAt),
    updatedAt: safeDate(d.data().updatedAt),
    completedAt: safeDate(d.data().completedAt),
  }));
}

export async function createSpaceTask(spaceId, data) {
  const user = auth.currentUser;
  if (!user) throw new Error("Not authenticated");

  const newTask = {
    ...data,
    title: data.title.trim(),
    spaceId: spaceId, // 🌟 Mandatory for isolation
    userId: user.uid,
    status: data.status || "todo", // Default for Kanban
    assignedToIds: data.assignedToIds || [user.uid],
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    completed: false
  };

  const docRef = await addDoc(tasksCol, newTask);
  return { id: docRef.id };
}

export async function updateSpaceTask(taskId, updates) {
  const ref = doc(db, "space_tasks", taskId);
  await updateDoc(ref, { 
    ...updates, 
    updatedAt: serverTimestamp() 
  });
}

export async function deleteSpaceTask(taskId) {
  await deleteDoc(doc(db, "space_tasks", taskId));
}
